import Image from 'next/image';
import { FC } from 'react';

import { SECTIONS_IDS } from '../../../constants/sections';
import { useLkBasePath } from '../../../hooks/use-lk-base-path';
import { ArrowsProtect1InV4Icon } from '../../icons/ArrowsProtect1InV4Icon';
import { ArrowsProtect1OutV4Icon } from '../../icons/ArrowsProtect1OutV4Icon';
import { ArrowsProtect2InV4Icon } from '../../icons/ArrowsProtect2InV4Icon';
import { ArrowsProtect2OutV4Icon } from '../../icons/ArrowsProtect2OutV4Icon';
import { ArrowsProtect3InV4Icon } from '../../icons/ArrowsProtect3InV4Icon';
import { ArrowsProtect3OutV4Icon } from '../../icons/ArrowsProtect3OutV4Icon';
import { ArrowsProtect4InV4Icon } from '../../icons/ArrowsProtect4InV4Icon';
import { ArrowsProtect4OutV4Icon } from '../../icons/ArrowsProtect4OutV4Icon';
import { ArrowsProtect5InV4Icon } from '../../icons/ArrowsProtect5InV4Icon';
import { ArrowsProtect5OutV4Icon } from '../../icons/ArrowsProtect5OutV4Icon';
import { Box } from '../common/Box';
import { ButtonLink } from '../common/ButtonLink';
import { Container } from '../common/Container';
import { Flex } from '../common/Flex';
import { Text } from '../common/Text';

import styles from './ProtectBlock.module.scss';

export const ProtectBlock: FC = () => {
  const lkBasePath = useLkBasePath();

  return (
    <Container id={SECTIONS_IDS.resources}>
      <div className={styles.root}>
        <Flex direction={'column'} gap={4}>
          <Text type={'h2'}>Operate with clarity — protect revenue by design</Text>

          <div className={styles.grid}>
            <Box
              iconIn={<ArrowsProtect1InV4Icon />}
              iconOut={<ArrowsProtect1OutV4Icon />}
              title="Reporting & Analytics"
              description="Unified reporting across methods, providers, entities, and time zones"
            />

            <Box
              iconIn={<ArrowsProtect2InV4Icon />}
              iconOut={<ArrowsProtect2OutV4Icon />}
              title="Anti-fraud"
              description="Risk rules, velocity checks, 3DS flows (if applicable), anomaly signals"
            />

            <Box
              iconIn={<ArrowsProtect3InV4Icon />}
              iconOut={<ArrowsProtect3OutV4Icon />}
              title="Reconciliation"
              description="Match transactions, fees, settlements, and payouts. Export to accounting systems"
            />

            <Box
              iconIn={<ArrowsProtect4InV4Icon />}
              iconOut={<ArrowsProtect4OutV4Icon />}
              title="Security & Compliance"
              description="PCI-ready approach, encryption, secure key handling, audit logs"
            />

            <Box
              iconIn={<ArrowsProtect5InV4Icon />}
              iconOut={<ArrowsProtect5OutV4Icon />}
              title="Settings & RBAC"
              description="Granular permissions per team: finance, support, risk, developers"
            />
          </div>

          <ButtonLink href={`${lkBasePath}/registration`} isOutsideLink>
            Start processing
          </ButtonLink>
        </Flex>

        <Flex justifyContent={'center'} alignItems={'center'} className={styles.rightSection}>
          <div className={styles.gif}>
            <Image
              src="/assets/sales-chart.png"
              alt="Sales chart"
              width={388}
              height={374}
              layout="responsive"
              sizes="(min-width: 960px) 388px, 0px"
            />
          </div>
        </Flex>
      </div>
    </Container>
  );
};
